import React from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import RouteScrollToTop from "./elements/RouteScrollToTop";
import ScrollToTop from "react-scroll-to-top";
import IndexPage from "./pages/IndexPage";
import HomeOne from "./pages/HomeOne";
import Home from "./pages/Home";
import HomeThree from "./pages/HomeThree";
import HomeFour from "./pages/HomeFour";
import HomeFive from "./pages/HomeFive";
import About from "./pages/About";
import Service from "./pages/Service";
import ServiceDetails from "./pages/ServiceDetails";
import Project from "./pages/Project";
import ProjectDetails from "./pages/ProjectDetails";
import Blog from "./pages/Blog";
import BlogDetails from "./pages/BlogDetails";
import Pricing from "./pages/Pricing";
import Team from "./pages/Team";
import TeamDetails from "./pages/TeamDetails";
import Contact from "./pages/Contact";
import Error from "./pages/Error";
import { AwsBlog, AWSService, AzureBlog, AzureService, CloudBlog, CloudManagementService, CyberSecurityService, DataManagementService } from "./data";

const App = () => {
  return (
    <>
      <BrowserRouter>
        <RouteScrollToTop />
        <ScrollToTop smooth color="#196164" />
        <Routes>
          <Route exact path="/" element={<Home />} />
            <Route exact path="/about" element={<About />} />
           <Route exact path="/services" element={<Service />} />
          <Route exact path="/home-1" element={<HomeOne />} />
          <Route exact path="/blog" element={<Blog />} />
 <Route exact path="/blog/aws" element={<BlogDetails  data={AwsBlog}/>} />
 <Route exact path="/blog/azure" element={<BlogDetails data={AzureBlog}/>} />
 <Route exact path="/blog/cloud-management" element={<BlogDetails data={CloudBlog}/>} />
    <Route exact path="/services/aws" element={<ServiceDetails data={AWSService}/>} />
    <Route exact path="/services/azure" element={<ServiceDetails data={AzureService}/>} />
    <Route exact path="/services/data-management" element={<ServiceDetails data={DataManagementService}/>} />
    <Route exact path="/services/cloud" element={<ServiceDetails data={CloudManagementService}/>} />
    <Route exact path="/services/cybersecurity" element={<ServiceDetails data={CyberSecurityService}/>} />
      
          {/* <Route exact path="/home-2" element={<HomeTwo />} />
          <Route exact path="/home-3" element={<HomeThree />} />
          <Route exact path="/home-4" element={<HomeFour />} />
          <Route exact path="/home-5" element={<HomeFive />} />
      
          <Route exact path="/project" element={<Project />} />
          <Route exact path="/project-details" element={<ProjectDetails />} />
         
          <Route exact path="/pricing" element={<Pricing />} />
          <Route exact path="/team" element={<Team />} />
          <Route exact path="/team-details" element={<TeamDetails />} />*/}
          <Route exact path="/contact" element={<Contact />} /> 
          <Route exact path="*" element={<Error />} />
        </Routes>
      </BrowserRouter>
    </>
  );
};

export default App;
